module.exports = __webpack_public_path__ + "img/组24.26a7e8c8.png";